import { render } from "./LoaderSpinner.vue?vue&type=template&id=34749bbe&scoped=true"
const script = {}

import "./LoaderSpinner.vue?vue&type=style&index=0&id=34749bbe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34749bbe"]])

export default __exports__